import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auditLog',
  templateUrl: './auditLog.component.html' 
})
export class AuditLogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
